export default __webpack_public_path__ + "static/media/laundry2-afterB-480w.e8d81faa.avif";